const RISCO_AGENCIA = {
    FT: { id: 'FT', descricao: 'Fitch' },
    SP: { id: 'SP', descricao: "Standard & Poor's" },
    MD: { id: 'MD', descricao: "Moody's" },
    B3: { id: 'B3', descricao: 'B3' },
    BC: { id: 'BC', descricao: 'BC' }
};

module.exports = RISCO_AGENCIA;
